<template>
  <BaseSwitch
    v-model="darkMode"
    :options="[
        {
          icon: 'sun',
          value: false
        },
        {
          icon: 'moon',
          value: true
        }
      ]"
    small
    v-test="'theme-toggle'"
  />
</template>

<script
  setup
  lang="ts"
>
import { useUserStore } from '@/stores/user';
import { Theme } from '@/types';

const { updateUser } = useUserStore();

const darkMode = computed({
  get: () => {
    const { user } = useUserStore();
    return user?.settings.custom.theme === Theme.Dark;
  },
  set: (value: boolean) => {
    updateUser({
      settings: {
        custom: {
          theme: value ? Theme.Dark : Theme.Light,
        },
      },
    });
  },
});
</script>
